export default __webpack_public_path__ + "static/media/b2c_commerce-1.ac5c58d5.png";